/* istanbul ignore file */
import { DateRangeFilterLayoutType } from '../../../DateRangeFilter';
import { Box } from '@mui/material';

const DateRangeFilterLayout: DateRangeFilterLayoutType = ({ children }: any) => {
  return (
    <Box className="daterange-inputs">
      <Box display="flex" flexWrap="nowrap">
        {children}
      </Box>
    </Box>
  );
};

export default DateRangeFilterLayout;
